<script setup lang="ts">
    import { reactive, ref } from 'vue';
    import { defineExpose } from "vue"
    import axios from 'axios';

    let admin: any = null;
    const isOpened = ref(false);
    const errorMessage = ref('');
    const loading = ref(false);
    const credentialsInfos = reactive({
        username: '',
        has_default_password: false,
        password: '',
        has_default_code_securite: false,
        mfa_security_key: '',
        mfa_enabled: 0,
        mfa_qr_code: ''
    });

    async function doFetchCredentialsInfos() {
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.get(`/backoffice/admins/get_credentials_infos/${admin.id}`);
            credentialsInfos.username = httpResponse.data.username;
            credentialsInfos.has_default_password = httpResponse.data.has_default_password;
            credentialsInfos.password = httpResponse.data.password;
            credentialsInfos.has_default_code_securite = httpResponse.data.has_default_code_securite;
            credentialsInfos.mfa_security_key = httpResponse.data.mfa_security_key;
            credentialsInfos.mfa_enabled = httpResponse.data.mfa_enabled;
            credentialsInfos.mfa_qr_code = httpResponse.data.mfa_qr_code;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function doResetPasswordAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/admins/reset_password/${admin.id}`, {});
            await doFetchCredentialsInfos();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function doEnableMFAAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/admins/enable_mfa/${admin.id}`, {});
            await doFetchCredentialsInfos();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function doDisableMFAAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/admins/disable_mfa/${admin.id}`, {});
            await doFetchCredentialsInfos();
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }

        return null;
    }
    
    async function open(selectedAdmin: any) {
        admin = selectedAdmin;
        await doFetchCredentialsInfos();
        isOpened.value = true;
    }

    function close() {
        isOpened.value = false;
    }

    defineExpose({ open, close });
</script>

<template>
    <custom-modal v-model:show="isOpened">
        <template #header>
            <h4 class="font-semibold">Informations de connexion</h4>
        </template>
        <div>
            <div class="form-field-floating lg reactive my-5">
                <input type="text" class="form-input" :value="credentialsInfos.username" name="identifiant" id="identifiant" placeholder="" readonly>
                <label for="identifiant">Identifiant</label>
            </div>
            <div class="form-field-floating lg reactive my-5">
                <input type="text" class="form-input" :value="credentialsInfos.password ?? '******'" name="password" id="password" placeholder="" readonly>
                <label for="password">Mot de passe</label>
            </div>
            <div v-if="credentialsInfos.mfa_qr_code">
                <div>QR Code MFA</div>
                <div style="text-align: center;">
                    <img :src="'data:image/png;base64,' + credentialsInfos.mfa_qr_code" height="200px" />
                </div>
            </div>
            <div class="form-field-floating lg reactive my-5" v-if="credentialsInfos.mfa_security_key">
                <input type="text" class="form-input" :value="credentialsInfos.mfa_security_key" name="mfa_security_key" id="mfa_security_key" placeholder="" readonly>
                <label for="mfa_security_key">Clé de sécurité MFA</label>
            </div>
        </div>
        <template #footer>
            <!-- <button class="btn-ultra white2" style="justify-content: center;" @click="doEnableMFAAction" v-if="credentialsInfos.mfa_enabled == 0">Activer la double authentification</button> -->
            <button class="btn-ultra white2" style="justify-content: center;" @click="doDisableMFAAction" v-if="credentialsInfos.mfa_enabled == 1">Réinitialiser la double authentification</button>
            <button class="btn-ultra white2" style="justify-content: center;" @click="doResetPasswordAction" v-if="credentialsInfos.has_default_password == false">Réinitialiser le mot de passe</button>
            <button class="btn-ultra white2" style="justify-content: center;" @click="isOpened = false">Fermer</button>
        </template>
    </custom-modal>
</template>
